import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledStar = styled.span.withConfig({
    componentId: "sc-5e924aca-0"
})([
    `display:inline-block;line-height:0;height:10px;width:10px;svg{display:inline-block;margin-left:-1px;margin-top:-1px;}&.star--full{background:#0e0e0f;}&.star--empty{background:#cccccc;}path{fill:#f0f1f1;}path{fill:#f0f1f1;}`,
    ``
], (p)=>p.fillPercentage && `
  background: linear-gradient(90deg, #0e0e0f ${p.fillPercentage}%, #cccccc 0%);
  `);
const Star = ({ fillPercentage })=>{
    const isFull = fillPercentage === 100;
    const isPartial = fillPercentage > 0 && !isFull;
    const type = isPartial ? 'partial' : isFull ? 'full' : 'empty';
    return _jsx(StyledStar, {
        className: `star star--${type}`,
        fillPercentage: isPartial && fillPercentage,
        children: _jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 12 12",
            xmlSpace: "preserve",
            height: 12,
            width: 12,
            children: _jsx("path", {
                d: "M0 0v12h12V0H0zm7.9 3.9 3.1.7-2 2.9.9 3.5L6 9.8 2.1 11 3 7.5 1 4.6l3.1-.7L6 1l1.9 2.9z"
            })
        })
    });
};
export default Star; //# sourceMappingURL=Star.js.map
